// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomDeletePopper_popperContainer__oIPFU {
  border: 1px solid #3a70ca !important;
  font-family: "Montserrat" !important;
  height: 100px !important;
  border-radius: 10px !important;
  width: 255px !important;
  height: 120px !important;
  position: relative !important;
  margin-top: 15px !important;
  margin-left: 10px !important;
}
.CustomDeletePopper_popperContainer__oIPFU:after {
  content: "" !important;
  display: block !important;
  position: absolute !important;
  border: 1px solid #3a70ca !important;
  border-width: 1px 0 0 1px !important;
  width: 15px !important;
  height: 15px !important;
  top: -8.5px !important;
  right: 19px !important;
  background: inherit !important;
  transform: rotate(45deg) !important;
}
.CustomDeletePopper_popperButtonContainer__sRWjP {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: inherit;
  margin-left: 60px !important;
}
.CustomDeletePopper_yesButton__p0lUQ {
  width: 57px !important;
  height: 30px !important;
  padding: 4px 10px 4px 10px !;
  gap: 8px !important;
  border-radius: 6px !important;
  opacity: 0px !;
  background: #00ab55 !important;
  color: #ffffff !important;
  font-family: "Montserrat" !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  line-height: 22px !important;
}
.CustomDeletePopper_noButton__ujSmF {
  width: 57px !important;
  height: 30px !important;
  padding: 4px 10px 4px 10px !;
  gap: 8px !important;
  border-radius: 6px !important;
  opacity: 0px !;
  border: 1px solid #00ab55 !important;
  color: #00ab55 !important;
  font-family: "Montserrat" !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  line-height: 22px !important;
}
.CustomDeletePopper_popperMessage__e7\\+k4 {
  font-family: "Montserrat" !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 17.07px !important;
  color: #000000;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomPopper/CustomDeletePopper.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,oCAAoC;EACpC,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAK9B,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,cAAc;AAChB","sourcesContent":[".popperContainer {\n  border: 1px solid #3a70ca !important;\n  font-family: \"Montserrat\" !important;\n  height: 100px !important;\n  border-radius: 10px !important;\n  width: 255px !important;\n  height: 120px !important;\n  position: relative !important;\n  margin-top: 15px !important;\n  margin-left: 10px !important;\n}\n.popperContainer:after {\n  content: \"\" !important;\n  display: block !important;\n  position: absolute !important;\n  border: 1px solid #3a70ca !important;\n  border-width: 1px 0 0 1px !important;\n  width: 15px !important;\n  height: 15px !important;\n  top: -8.5px !important;\n  right: 19px !important;\n  background: inherit !important;\n\n  -webkit-transform: rotate(45deg) !important;\n  -moz-transform: rotate(45deg) !important;\n  -o-transform: rotate(45deg) !important;\n  transform: rotate(45deg) !important;\n}\n.popperButtonContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  padding: inherit;\n  margin-left: 60px !important;\n}\n.yesButton {\n  width: 57px !important;\n  height: 30px !important;\n  padding: 4px 10px 4px 10px !;\n  gap: 8px !important;\n  border-radius: 6px !important;\n  opacity: 0px !;\n  background: #00ab55 !important;\n  color: #ffffff !important;\n  font-family: \"Montserrat\" !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  line-height: 22px !important;\n}\n.noButton {\n  width: 57px !important;\n  height: 30px !important;\n  padding: 4px 10px 4px 10px !;\n  gap: 8px !important;\n  border-radius: 6px !important;\n  opacity: 0px !;\n  border: 1px solid #00ab55 !important;\n  color: #00ab55 !important;\n  font-family: \"Montserrat\" !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  line-height: 22px !important;\n}\n.popperMessage {\n  font-family: \"Montserrat\" !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 17.07px !important;\n  color: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popperContainer": `CustomDeletePopper_popperContainer__oIPFU`,
	"popperButtonContainer": `CustomDeletePopper_popperButtonContainer__sRWjP`,
	"yesButton": `CustomDeletePopper_yesButton__p0lUQ`,
	"noButton": `CustomDeletePopper_noButton__ujSmF`,
	"popperMessage": `CustomDeletePopper_popperMessage__e7+k4`
};
export default ___CSS_LOADER_EXPORT___;
